// extracted by mini-css-extract-plugin
export var box = "Accordion-module--box--fbdd9";
export var box_md = "Accordion-module--box_md--62052";
export var box_xmd = "Accordion-module--box_xmd--8398b";
export var box_flex = "Accordion-module--box_flex--ffeca";
export var box_lg = "Accordion-module--box_lg--a9ea5";
export var box_sm = "Accordion-module--box_sm--ae258";
export var box_outer = "Accordion-module--box_outer--cf68e";
export var box_whiteBg = "Accordion-module--box_white-bg--6732e";
export var box_noMarginBottom = "Accordion-module--box_no-margin-bottom--8012f";
export var box_noPadding = "Accordion-module--box_no-padding--6b8a4";
export var box_outerGray = "Accordion-module--box_outer-gray--bd299";
export var box_dark = "Accordion-module--box_dark--5d3f9";
export var box_zIndex = "Accordion-module--box_z-index--972e3";
export var box_zIndex6 = "Accordion-module--box_z-index-6--d5b91";
export var box_eventsWithLine = "Accordion-module--box_events-with-line--d7adb";
export var box_featuresAo = "Accordion-module--box_features-ao--cf3a5";
export var box_verticalPaddings = "Accordion-module--box_vertical-paddings--6abbb";
export var clearP = "Accordion-module--clearP--569f2";
export var clearP_vc = "Accordion-module--clearP_vc--809d1";
export var wrapper = "Accordion-module--wrapper--dda65";
export var faq = "Accordion-module--faq--3c897";
export var panel = "Accordion-module--panel--497d3";
export var title = "Accordion-module--title--71eeb";
export var panelContentWrapper = "Accordion-module--panelContentWrapper--4bee0";
export var active = "Accordion-module--active--e32ea";
export var collapse = "Accordion-module--collapse--318ed";
export var fadeInAnimation = "Accordion-module--fadeInAnimation--d94d6";
export var placeHolderShimmer = "Accordion-module--placeHolderShimmer--35223";